module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "data-exist": _vm.exist
    }
  }, [_c('div', {
    ref: "banner",
    attrs: {
      "data-is": "bc-banner",
      "data-autoload": "false",
      "data-ui": _vm.ui,
      "data-screen": _vm.screen,
      "data-type": _vm.type,
      "data-size": _vm.size,
      "data-force-mq": _vm.forceMq,
      "data-fixed": _vm.fixed,
      "data-expel-fixed": _vm.expelFixed,
      "data-z-index": _vm.zIndex
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb4e79e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/banners/BcBanner.vue
// module id = 348
// module chunks = 1